import React from "react";
import { Select, Input } from "antd";
import { cx } from "../../utils/classNames";

const { TextArea } = Input;

export function Field({ label, hint, className, children }) {
  return (
    <label className={cx("field", className)}>
      {label && <span className="field-label">{label}</span>}
      {children}
      {hint && <div className="field-hint">{hint}</div>}
    </label>
  );
}
export function InputField({
  label,
  hint,
  className,
  inputClassName,
  value,
  onChange,
  ...rest
}) {
  return (
    <Field label={label} hint={hint} className={className}>
      <Input
        className={cx("field-input-control", inputClassName)}
        value={value}
        onChange={onChange}
        {...rest}
      />
    </Field>
  );
}
export function TextAreaField({
  label,
  hint,
  className,
  value,
  onChange,
  rows = 4,
}) {
  return (
    <Field label={label} hint={hint} className={className}>
      <TextArea
        className="field-textarea-control"
        value={value}
        rows={rows}
        onChange={onChange}
      />
    </Field>
  );
}

export function SelectField({
  label,
  hint,
  className,
  options = [],
  value,
  onChange,
}) {
  return (
    <Field label={label} hint={hint} className={className}>
      <Select
        className="field-select-control"
        value={value}
        onChange={(val) => onChange?.({ target: { value: val } })}
        options={options.map((opt) => ({
          value: opt.value ?? opt,
          label: opt.label ?? opt,
        }))}
      />
    </Field>
  );
}

export default Field;
